import { idCardHide } from 'utils/ruleType'
import "../static/css/contribution.css";

export function BpmContributionTitle(props) {
  const { title, totalMonth } = props;
  return (
    <div className="co-title">
      {title}
      <span>
        <b>累计月份：{totalMonth} 个月</b>
      </span>
    </div>
  );
}
export function BpmContributionDate(props) {
  const { year, month, name, idNum } = props;
  //对月份进行渲染处理
  const newMonth = month?.replace(/,/g, '月,')
  return (
    <div className="co-card">
      <p>
        <b>缴费人：{idCardHide(name, 1, name.length - 1)} </b>
      </p>
      <p>
        <b>身份证号码：{idCardHide(idNum)}</b>
      </p>
      <p>
        <b>年份：{year}年</b>
      </p>
      <p>
        <b>月份：{newMonth}月</b>
      </p>
    </div>
  );
}
